import { Radio, RadioGroup, Stack, Typography } from "@mui/material";
import React, { Dispatch, useEffect, useState } from "react";

import IContactInfo from "../Types/IContactInfo";
import ContactInfoDisplay, { OverrideContactType } from "./ContactInfoDisplay";

export interface IContactOverrideFormProps {
  customer: IContactInfo;
  contact: IContactInfo;
  setOverrideContact: Dispatch<boolean>;
}

export const contactOverrideFormPatientIdentifier = "Existing Patient";
export const contactOverrideFormContactIdentifier = "New Contact";

export const formNames = { overrideContact: "radio-override-contact" };

const ContactOverrideForm: React.FC<IContactOverrideFormProps> = ({ customer, contact, setOverrideContact }) => {
  const [selection, setSelection] = useState<OverrideContactType>(contactOverrideFormContactIdentifier);

  useEffect(() => {
    if (selection === contactOverrideFormPatientIdentifier) setOverrideContact(true);
    else setOverrideContact(false);
  }, [selection]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = (event.target as HTMLInputElement).value;

    if (value !== contactOverrideFormPatientIdentifier && value !== contactOverrideFormContactIdentifier) return;

    setSelection(value);
  };

  return (
    <Stack direction="column" spacing={2}>
      <Typography>
        Phone and/or Email differs between the selected Patient and the Contact. Please select which contact information
        to proceed with.
      </Typography>

      <RadioGroup name={formNames.overrideContact} value={selection} onChange={handleChange}>
        <Stack direction="column" spacing={2}>
          <Stack direction="row" spacing={2} alignItems="center">
            <Radio color="primary" value={contactOverrideFormContactIdentifier} />
            <ContactInfoDisplay
              contactInfo={contact}
              contactType={contactOverrideFormContactIdentifier}
              selected={selection === contactOverrideFormContactIdentifier}
            />
          </Stack>

          <Stack direction="row" spacing={2} alignItems="center">
            <Radio color="primary" value={contactOverrideFormPatientIdentifier} />
            <ContactInfoDisplay
              contactInfo={customer}
              contactType={contactOverrideFormPatientIdentifier}
              selected={selection === contactOverrideFormPatientIdentifier}
            />
          </Stack>
        </Stack>
      </RadioGroup>
    </Stack>
  );
};

export default ContactOverrideForm;
